const TAB_KEY = 'visibleCompanies'
export default {
  data () {
    return {
      visibleCompaniesTabKey: TAB_KEY
    }
  },

  computed: {
    visibleCompaniesEditConfig () {
      return {
        title: this.$t('base/user.visible_companies'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'base',
            route: `user/${this.$route.params.id}/visible-companies`
          },
          post: {
            module: 'base',
            route: `user/${this.$route.params.id}/visible-companies`
          }
        },
        modifyDataBeforeSend: (event) => this.modifyVisibleCompaniesData(event),
        hiddenFormKeys: [
          'visible_companies'
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base/user.visible_companies'),
            showBackButton: {
              onGoBack: () => this.goBack()
            }
          },
          {
            component: this.dropdownSelectionListComponent,
            dropdownFieldConfig: {
              key: 'visible_companies',
              label: this.$t('base/user.visible_companies'),
              autocomplete_options: {
                module: 'base',
                route: 'companies/autocomplete',
                allowSearch: true,
                query: (event) => {
                  const query = {
                    exclude_auth_company: true
                  }
                  if (event?.allItems) {
                    query.limitResults = false
                  }

                  return query
                }
              },
              creatable: true,
              editable: true,
              visible: true
            }
          }
        ]
      }
    }
  },

  methods: {
    modifyVisibleCompaniesData (event) {
      const { copiedData } = event || {}

      if (copiedData?.visible_companies?.length) {
        copiedData.visible_companies = copiedData.visible_companies.map(company => company?.id).filter(company => company)
      }
      else {
        delete copiedData.visible_companies
      }

      return copiedData
    }
  }
}
